// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Private Endpoint Service API
 * private-endpoint-service-api manages Private Endpoint Services in ingress clusters
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-networking@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrchestraEndpointState } from './OrchestraEndpointState';
import {
  OrchestraEndpointStateFromJSON,
  OrchestraEndpointStateFromJSONTyped,
  OrchestraEndpointStateToJSON,
  OrchestraEndpointStateToJSONTyped,
} from './OrchestraEndpointState';
import type { NetworkServiceDetails } from './NetworkServiceDetails';
import {
  NetworkServiceDetailsFromJSON,
  NetworkServiceDetailsFromJSONTyped,
  NetworkServiceDetailsToJSON,
  NetworkServiceDetailsToJSONTyped,
} from './NetworkServiceDetails';

/**
 * Connection health for one orchestra cluster.
 * @export
 * @interface OrchestraConnection
 */
export interface OrchestraConnection {
  /**
   * VPC endpoint IDs created by the operator for this orchestra, keyed by endpoint ID.
   * @type {{ [key: string]: OrchestraEndpointState; }}
   * @memberof OrchestraConnection
   */
  configuredEndpoints?: { [key: string]: OrchestraEndpointState };
  /**
   *
   * @type {NetworkServiceDetails}
   * @memberof OrchestraConnection
   */
  targetService?: NetworkServiceDetails;
}

/**
 * Check if a given object implements the OrchestraConnection interface.
 */
export function instanceOfOrchestraConnection(
  value: object,
): value is OrchestraConnection {
  return true;
}

export function OrchestraConnectionFromJSON(json: any): OrchestraConnection {
  return OrchestraConnectionFromJSONTyped(json, false);
}

export function OrchestraConnectionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): OrchestraConnection {
  if (json == null) {
    return json;
  }
  return {
    configuredEndpoints:
      json['configured_endpoints'] == null
        ? undefined
        : mapValues(
            json['configured_endpoints'],
            OrchestraEndpointStateFromJSON,
          ),
    targetService:
      json['target_service'] == null
        ? undefined
        : NetworkServiceDetailsFromJSON(json['target_service']),
  };
}

export function OrchestraConnectionToJSON(json: any): OrchestraConnection {
  return OrchestraConnectionToJSONTyped(json, false);
}

export function OrchestraConnectionToJSONTyped(
  value?: OrchestraConnection | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    configured_endpoints:
      value['configuredEndpoints'] == null
        ? undefined
        : mapValues(value['configuredEndpoints'], OrchestraEndpointStateToJSON),
    target_service: NetworkServiceDetailsToJSON(value['targetService']),
  };
}
